import { AbstractControl, ValidationErrors } from '@angular/forms';


// 👧👧🔥🔥🔥🔥🔥 ------------------------------------Validor est un fichier qui contient les fonctions qui permettent de gerer les messages d'erreurs de formulaire de jeu d'enregistrement où l'utilisateur saisit entré

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input email
export function emailValidator(controlName: string) {
  return (control: AbstractControl): ValidationErrors | null => {
    let format='^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
    return !control.value.length
      ? { error: true, message: `L'adresse ${controlName} est obligatoire.` }
      : !control.value.match(new RegExp(format))
      ? { error: true, message: `L'${controlName} doit respecter le format : yohan@gmail.com.` }
      : null;
  };
}


// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input mot de passe
export function passWordValidator(controlName: string, lengthWord:number) {
  return (control: AbstractControl): ValidationErrors | null => {

    return !control.value.length
      ? { error: true, message: `${controlName} est obligatoire.` }
      : control.value.length<lengthWord
      ? { error: true, message: `${controlName} doit contenir au moins ${lengthWord} caractères.` }
      // :((control.value != null) && (control.value.startsWith(' ') && control.value.endsWith(' ')))
      // ?  {  error: true, message: `Ce champs ne peut pas contenir des espaces.` }
      : null;

  };
}

export function nameValidator_v1(controlName: string, minlength: number, maxlength: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    let pattern = '^[A-Za-zéàèîôêûïëüö -|/]+$'; // Ajout de | et / au motif
    return !control.value.length
      ? { error: true, message: `${controlName} est obligatoire.` }
      : !control.value.match(new RegExp(pattern))
      ? {
          error: true,
          message: `${controlName} ne doit contenir que des lettres, | ou /.`,
        }
        : ((control.value != null) && control.value.trim().length === 0)
        ? { error: true, message: `${controlName} ne doit pas contenir que des espaces vide.` }
        : control.value.length < minlength
        ? {
            error: true,
            message: `${controlName} doit contenir au moins ${minlength} caractères.`,
          }
        : control.value.length > maxlength
        ? {
            error: true,
            message: `${controlName} doit contenir au plus ${maxlength} caractères.`,
          }
        : null;
  };
}


// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input nom
export function nameValidator( controlName: string, minlength: number, maxlength: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    let pattern='^[A-Za-zéàèîôêûïëüö -]+$';
    return !control.value.length
      ? { error: true, message: `${controlName} est obligatoire.` }
      : !control.value.match(new RegExp(pattern))
      ? {
          error: true,
          message: `${controlName} ne doit contenir que des lettres.`,
        }
        :((control.value != null) && control.value.trim().length === 0)
        //invalid, return error object
      ?  {  error: true, message: `${controlName} ne doit pas être vide.` }
        : control.value.length < minlength
        ? {
            error: true,
            message: `${controlName} doit contenir au moins  ${minlength} caractères.`,
          }
        : control.value.length > maxlength
        ? {
            error: true,
            message: `${controlName} doit contenir au plus ${maxlength} caractères.`,
          }
        : null;
  };
}

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input username
export function usernameValidator(
  controlName: string,
  minlength: number,
  maxlength: number
) {
  return (control: AbstractControl): ValidationErrors | null => {

    let patternalphabets = '^[A-Za-z0-9.-]+$';
    // let patternLettre=''^[A-Za-zéàèîôêûïëüö -]+$'';
    // let patternChiffre='';
    // let patternawithoutpace='';
    // let patternSpace = '^[a-zA-Z]{' + minlength + ',' + maxlength + '}$';
    return !control.value.length
      ? { error: true, message: `${controlName} est obligatoire.` }
      : !control.value.match(new RegExp(patternalphabets))
      ? {
          error: true,
          message: `${controlName} ne doit contenir que des lettres et des chiffres.`,
        }
        :((control.value != null) && (control.value.startsWith(' ') || control.value.endsWith(' ')))
        //invalid, return error object
        ?  {  error: true, message: `Ce champs ne peut pas contenir des espaces.` }

      // :((control.value != null) && (control.value.trim().length === 0 || control.value.startsWith(' ') || control.value.endsWith(' ')))
      // ? { error: true,
      //   'notOnlyWhitespace': true,
      //   message: `${controlName} ne doit pas contenir d'espace`
      // }
        // : !control.value.match(/^([a-zA-Z]+\s)*[a-zA-Z]+$/)
        //   ? {
        //       error: true,
        //       message: `Les espaces ne sont pas autorisés.`,
        //     }
        : control.value.length < minlength
        ? {
            error: true,
            message: ` ${controlName} doit contenir au moins ${minlength} caractères.`,
          }
        : control.value.length > maxlength
        ? {
            error: true,
            message: `${controlName}  doit contenir au plus  ${maxlength} caractères.`,
          }
        : null;
  };
}

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input numero de telephone
export function phoneValidator(controlName: string, minLength: number,maxLength: number) {
  let pattern = '^[0-9+]+(\.?[0-9]+)?$';
  /* Add an extra backslash before \d if regex is constructed as a string. There is no need for // at the beginning and end of string if using RegExp  */
  return (control: AbstractControl): ValidationErrors | null => {
    return !control.value.length
      ? { error: true, message: `${controlName} est obligatoire.` }
      : !control.value.match(new RegExp(pattern))
      ? {
          error: true,
          message: `${controlName} ne doit contenir que des chiffres.`,
        }
        : control.value.length <minLength
      ? {
          error: true,
          message: `${controlName} doit contenir au moins  ${minLength} chiffres.`,
        }
      :  control.value.length >maxLength
      ? {
          error: true,
          message: `${controlName} doit contenir au plus  ${maxLength} chiffres.`,
        }
      : null;
  };
}

export function allNumberValidator(controlName: string, minLength: number,maxLength: number) {
  let pattern = '^[0-9+]+(\.?[0-9]+)?$';
  /* Add an extra backslash before \d if regex is constructed as a string. There is no need for // at the beginning and end of string if using RegExp  */
  return (control: AbstractControl): ValidationErrors | null => {
    return !control.value.length
      ? { error: true, message: `${controlName} est obligatoire.` }
      : !control.value.match(new RegExp(pattern))
      ? {
          error: true,
          message: `${controlName} ne doit contenir que des chiffres.`,
        }
        : control.value.length <minLength
      ? {
          error: true,
          message: `${controlName} doit contenir au moins  ${minLength} chiffres.`,
        }
      :  control.value.length >maxLength
      ? {
          error: true,
          message: `${controlName} doit contenir au plus  ${maxLength} chiffres.`,
        }
      :((control.value != null) && (control.value.trim().length === 0 || control.value.startsWith(' ') || control.value.endsWith(' ')))
      ?{
          error: true,
          message: `Les espaces de débuts ou de fin ne sont pas autorisées..`,
      }
      : null;
  };
}

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input date
export function dateValidator(controlName: string) {
  return (control: AbstractControl): ValidationErrors | null => {
    let today = new Date();
    let selectedDate = new Date(control.value);
    return !control.value.length
      ? { error: true,
        message: `${controlName} est obligatoire` }
      : selectedDate.getTime() > today.getTime()
      ? { error: true, message: `${controlName} ne peut pas être une date future.` }
      : null;
  };
}

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input de chiffres quelconques
  export function numberValidator(controlName: string, minLength: number) {
    // let pattern = '^\\d{' + expectedLength + '}$';
    let numberPatern='/^-?(0|[1-9]\d*)?$/';
    /* Add an extra backslash before \d if regex is constructed as a string. There is no need for // at the beginning and end of string if using RegExp  */
    return (control: AbstractControl): ValidationErrors | null => {
      return !control.value.length
        ? { error: true, message: `${controlName} est obligatoire.` }
        : control.value.length <minLength
        ? {
            error: true,
            message: `${controlName} doit avoir au moins ${minLength} chiffres.`,
          }
        : null;
    };
  }

  // 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input quelconque , obligatoire
  export function requiredValidator(controlName: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      return !control?.value?.length
        ? { error: true, message: `${controlName} est obligatoire.` }
        : null;
    };
  }

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input quelconque , pour ne pas prendre en comptes des espaces blanc

  export function notOnlyWhitespace(controlName: string){
    return (control: AbstractControl): ValidationErrors | null => {

      return ((control.value != null) && (control.value.trim().length === 0 || control.value.startsWith(' ') || control.value.endsWith(' ')))
      ? { error: true,
        'notOnlyWhitespace': true,
        message: `${controlName} ne doit pas contenir d'espace.` }
      : null;
    }
  }

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input date
export function fileValidator(controlName: string, file : File) {
  // alert("ook")
  // console.log("fonction validator")
  // console.log(file)
  return (control: AbstractControl): ValidationErrors | null => {

    return !control.value
      ? { error: true,
        message: `${controlName} est obligatoire.` }
    : ( file.size< 2000)
      ? { error: true, message: `type` }
      : null;
  };
}

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input nom
export function genderValidator() {
  return (control: AbstractControl): ValidationErrors | null => {

    let patternalphabets = '^([A-Za-zéàèîôêûïëüö -]+\s)*[a-zA-Z]+$';
    // let patternLettre=''^[A-Za-zéàèîôêûïëüö -]+$'';
    // let patternChiffre='';
    // let patternawithoutpace='';
    // let patternSpace = '^[a-zA-Z]{' + minlength + ',' + maxlength + '}$';
    return !control.value.length
      ? { error: true, message: `Le genre est obligatoire.` }
      :null

  }
}


// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input boutique
export function nameBoutiqueValidator(
  controlName: string,
  minlength: number,
  maxlength: number
) {
  return (control: AbstractControl): ValidationErrors | null => {

    // let patternalphabets = '^([A-Za-zéàèîôêûïëüö -]+\s)*[a-zA-Z]+$';
    let patternAlpha='^(\s)*[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ&-çèêâû -]+$';
    let patternalphabets2 = '^(\s)*[0-9]+$';
    // let patternChiffre='';
    // let patternawithoutpace='';
    // let patternSpace = '^[a-zA-Z]{' + minlength + ',' + maxlength + '}$';
    return !control.value.length
      ? { error: true, message: `${controlName} est obligatoire.` }
      : !control.value.match(new RegExp(patternAlpha))
      ? {
          error: true,
          message: `${controlName} ne doit pas contenir des caracteres spéciaux.`,
        }
        :((control.value != null) && control.value.trim().length === 0)
          ? {  error: true, message: `${controlName} ne doit pas être vide.` }

        : control.value.length < minlength
        ? {
            error: true,
            message: `${controlName} doit contenir au moins ${minlength} caractères.`,
          }
      :((control.value != null) && (control.value.trim().length === 0 || control.value.startsWith(' ') || control.value.endsWith(' ')))
      ?{
        error: true,
        message: `Les espaces de débuts ou de fin ne sont pas autorisées..`,
      }
      : control.value.length > maxlength
      ? {
          error: true,
          message: `${controlName} doit contenir au plus ${maxlength} caractères.`,
        }
        : control.value.match(new RegExp(patternalphabets2))
        ?{
            error: true,
            message: `${controlName} ne doit pas contenir que des chiffres.`,
        }
      : null;
  };
}

// 👧👧🔥🔥🔥🔥🔥 -----Gestion de messages d'erreurs du champs input nom
export function alphaNumericValidator(
  controlName: string,
  minlength: number,
  maxlength: number
) {
  return (control: AbstractControl): ValidationErrors | null => {

    let patternalphabets = '^(\s)*[a-zA-Z0-9éàèîôêûïëüö -]+$';
    // let patternLettre=''^[A-Za-zéàèîôêûïëüö -]+$'';
    // let patternChiffre='';
    // let patternawithoutpace='';
    // let patternSpace = '^[a-zA-Z]{' + minlength + ',' + maxlength + '}$';
    return !control.value.length
      ? { error: true, message: `${controlName} est obligatoire.` }
      : !control.value.match(new RegExp(patternalphabets))
      ? {
          error: true,
          message: `${controlName} ne doit contenir que des lettres et des chiffres.`,
        }

        :((control.value != null) && (control.value.startsWith(' ') && control.value.endsWith(' ')))
        ? {  error: true, message: `Ce champs ne peut pas contenir des espaces.` }

        : control.value.length < minlength
        ? {
            error: true,
            message: `${controlName} doit contenir au moins ${minlength} caractères.`,
          }
        : control.value.length > maxlength
        ? {
            error: true,
            message: `${controlName} doit contenir au plus ${maxlength} caractères.`,
          }
        : null;
  };
}

export function checkValidator(
  controlName: string,
  minlength: number,
  maxlength: number
) {
  return (control: AbstractControl): ValidationErrors | null => {

    let patternalphabets = '^([A-Za-zéàèîôêûïëüö -]+\s)*[a-zA-Z]+$';
    // let patternLettre=''^[A-Za-zéàèîôêûïëüö -]+$'';
    // let patternChiffre='';
    // let patternawithoutpace='';
    // let patternSpace = '^[a-zA-Z]{' + minlength + ',' + maxlength + '}$';
    return !control.value.match(new RegExp(patternalphabets))
      ? {
          error: true,
          message: `${controlName} ne doit contenir que des lettres.`,
        }
        : !control.value.match(/^([a-zA-Z]+\s)*[a-zA-Z]+$/)
          ? {
              error: true,
              message: `Les espaces ne sont pas autorisés.`,
            }
        :((control.value != null) && (control.value.startsWith(' ') && control.value.endsWith(' ')))
        ? {  error: true, message: `Ce champs ne peut pas contenir des espaces.` }

        : control.value.length < minlength
        ? {
            error: true,
            message: `${controlName} doit contenir au moins ${minlength} caractères.`,
          }
        : control.value.length > maxlength
        ? {
            error: true,
            message: `${controlName} doit contenir au plus ${maxlength} caractères.`,
          }
        : null;
  };
}


export function passValidator(
  controlName: string,

) {
  return (control: AbstractControl): ValidationErrors | null => {

    let patternalphabets = '^([A-Za-zéàèîôêûïëüö -]+\s)*[a-zA-Z]+$';
    // let patternLettre=''^[A-Za-zéàèîôêûïëüö -]+$'';
    // let patternChiffre='';
    // let patternawithoutpace='';
    // let patternSpace = '^[a-zA-Z]{' + minlength + ',' + maxlength + '}$';
    return !control.value.match(new RegExp(patternalphabets))
      ? {
          error: true,
          message: `${controlName} ne doit contenir que des lettres.`,
        }
        : !control.value.match(/^([a-zA-Z]+\s)*[a-zA-Z]+$/)
          ? {
              error: true,
              message: `Les espaces ne sont pas autorisés.`,
            }
        :((control.value != null) && (control.value.startsWith(' ') && control.value.endsWith(' ')))
        ? {  error: true, message: `Ce champs ne peut pas contenir des espaces.` }


        : null;
  };
}


